import styled from 'styled-components';
import { caption, colors, fontSizes, link2, spacing } from 'ui/theme';
import { GhostButton } from 'ui/button';
import { TagGroup } from 'ui/tags';

export const BaseCellWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  font-size: ${fontSizes.s14};
  > :nth-child(2) {
    width: 100%;
  }
`;

export const CustomDateDisplayWrapper = styled(BaseCellWrapper)`
  color: ${colors.grey50};
`;

export const TableCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;

  > :nth-child(2) {
    width: 100%;
  }
`;

export const WinningCriteriaCellStyle = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const WordBreakLabel = styled.span`
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const NameCellWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
`;

export const NameInfoWrapper = styled.div`
  align-items: center;
  color: ${colors.secondaryText};
  font-size: ${fontSizes.s12};
  display: flex;
  column-gap: ${spacing.quarter};
  flex-wrap: wrap;
`;

export const ExpandedCell = styled.div`
  grid-column: 1 / span 4;
  grid-row: 2 / span 1;
`;

export const ArrowButton = styled(GhostButton)`
  cursor: pointer;
`;

export const VariationCountLabel = styled.div`
  color: ${colors.grey50};
  margin-right: ${spacing.quarter};
  white-space: nowrap;
`;

export const VariationTestSubjectContent = styled.div`
  align-items: center;
  color: ${colors.textSecondary};
  display: flex;
  grid-column: 2 / span 2;
`;

export const VariationItem = styled.div`
  column-gap: ${spacing.base};
  display: grid;
  grid-template-columns: minmax(0, 1.24fr) minmax(0, 1fr);
  word-break: break-all;
`;

export const VariationList = styled.div`
  display: grid;
  row-gap: ${spacing.base};
  padding-bottom: ${spacing.half};
`;

export const ExperimentDetailItem = styled.div`
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s12};
  line-height: ${spacing.base};
`;

export const ExperimentDetails = styled.div`
  padding: ${spacing.base} 0 ${spacing.base} 0;
`;

export const NameCellInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: ${spacing.base};
`;

export const StyledNameLink = styled.a`
  ${link2}
  color: ${colors.textPrimary};
  text-decoration-color: transparent;
  font-weight: 400;
`;

export const StyledTagGroup = styled(TagGroup)`
  display: inline;
`;

export const CaptionText = styled.div`
  ${caption};
  color: ${colors.textSecondary};
`;
